export class Category {
    CategoryName: string;
    CategoryId: string;
    SubCategoryId: string;
    Percentage: string;
    CategoryType: string = '';
    TicketCount: number = 0;
    IncludedKeywords: string[] = [];
    ExcludedKeywords: string[] = [];
    strIncludedKeywords: string;
    strExcludedKeywords: string;
    includedBtnName: string;
    excludedBtnName: string;
    includeContainsText_1: string;
    includeContainsText_2: string;
    includeContainsText_3: string;
    includeContainsText_4: string;
    includeNotContainsText_1: string;
    includeNotContainsText_2: string;
    includeNotContainsText_3: string;
    includeNotContainsText_4: string;
    excludeText_1: string;
    excludeText_2: string;
    excludeText_3: string;
    excludeText_4: string;
    IsDashboardEnabled: boolean = false;
    selectedIndex_included: number = 0;
    selectedIndex_excluded: number = 0;
    included_keyword: string;
    excluded_keyword: string;
    ExitCondition: number;
    No_Cluster: number;
    ReCategorizeEnabled: boolean = false;
    TAT: number;
}